"use strict";

// customDirectEventTypes doesn't exist in react-native-web, therefore importing it
// directly in createHandler.tsx would end in crash.
const customDirectEventTypes = {};
export { customDirectEventTypes };
//# sourceMappingURL=customDirectEventTypes.web.js.map